

export class CostReviewSecurityEnUsManagementStation {
  isManagementStationChecked!: boolean;
  managementStation!: string;
}
